import { useState, useRef, useEffect } from 'react';
import { useHistory } from "react-router";
import { Button } from 'react-bootstrap';
import Sidebar from '../../../components/Navigation/Sidebar';
import Grid from "../../../components/Grid";
import Topbar from '../../../components/Navigation/Topbar';
import Header from '../../../components/Page/header';
import { buttonIcon, buttonTypes } from "../../../utils/buttonsUtil";
import SwitchOfStateBotModal from '../../../components/Modal/AutomaticAssigmentAlert/SwitchOfStateBot';
import ShowJsonDetailModal from '../../../components/Modal/AutomaticAssigmentAlert/ShowJsonDetail';
import { Show } from '../../../hooks/Show';
import { connect } from 'react-redux';

const ParameterizationAssigner = ({
    allAutomaticAsignmentRules,
    reduxGetAutomaticAssigmentRules,
    reduxSwitchBotStateAutomaticAssigment,
    reduxResetBotAutomaticAssingment,
    switchBotAutomaticAssingment,
}) => {
    const history = useHistory();
    const searchRef = useRef("");

    const [showJsonDetailModal, setShowJsonDetailModal] = useState(false);
    const [switchChecked, setSwitchChecked] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [offset, setOffset] = useState(10);
    const [selectedRule, setSelectedRule] = useState({});

    useEffect(() => {
        reduxGetAutomaticAssigmentRules({
            page: currentPage,
            offset: offset,
            search: searchRef.current,
        });
    }, [offset, currentPage])

    useEffect(() => {        
        if (switchBotAutomaticAssingment && switchBotAutomaticAssingment.redirectTo) {
            history.push(switchBotAutomaticAssingment.redirectTo);
        }

        return () => {
            reduxResetBotAutomaticAssingment();
        }
    }, [switchBotAutomaticAssingment])
    
    const columns = [
        {
            title: "#",
            render: (rowData) => <span>{rowData.id ? rowData.id : ''}</span>,
            field: 'id',
            searchable: true
        },
        {
            title: "Descripcion",
            render: (rowData) => {
                return (<span> {rowData.description ? rowData.description : ''}</span>
                );
            },
            field: 'description',
            searchable: true
        },
        {
            title: "Condiciones",
            render: (rowData) => {
                return (<span>{rowData.conditions ? JSON.stringify(rowData.conditions) : ''} </span>);
            },
            field: 'conditions',
        },
        {
            title: "then",
            render: (rowData) => {
                return (<span>{rowData.then ? JSON.stringify(rowData.then) : ''} </span>);
            },
            field: 'then',
        },
        {
            title: "Prioridad",
            render: (rowData) => <span>{rowData.priority ? rowData.priority : ''}</span>,
            field: 'priority',
            searchable: true,
        },
        {
            title: "Metadata",
            render: (rowData) => {
                return (<span>{rowData.metadata ? JSON.stringify(rowData.metadata) : ''} </span>);
            },
            field: 'metadata',
        },
        {
            title: "Acciones",
            render: (rowData) => {
                return (
                    <>
                        <button
                            title="Ver detalle de la regla"
                            className="btn btn-primary btn-sm  btn-circle mr-2"
                            type="button"
                            onClick={(e) => {
                                setShowJsonDetailModal(true);
                                setSelectedRule(rowData);
                            }}
                        >
                            <i className={`fas ${buttonIcon.Eye} fa-xs`}></i>
                        </button>
                    </>
                )
            },
            field: 'city.description',
        },
    ];

    return (
        <div id='wrapper'>
            <Sidebar />
            <div id='content-wrapper' className='d-flex flex-column'>
                <div id='content'>
                    <Topbar />
                    <div className='container-fluid'>
                        <Header title={"Modulo de parametrización"} />

                        <div className='card shadow mb-4'>
                            <div className='card-header py-3'>
                                <h6 className='m-0 font-weight-bold text-primary'>Listado de reglas</h6>
                            </div>

                            <Show when="feature:show-change-state-automatic-assignment-bot">
                                <div className='d-flex flex-row align-items-center justify-content-end mt-2'>
                                    <Button
                                        className='mr-2'
                                        variant='success'
                                        onClick={() => {
                                            reduxSwitchBotStateAutomaticAssigment({
                                                switchTo: "start"
                                            })
                                        }}>
                                            Iniciar Bot
                                    </Button>

                                    <Button
                                        className='mr-4'
                                        variant='danger'
                                        onClick={() => {
                                            reduxSwitchBotStateAutomaticAssigment({
                                                switchTo: "stop"
                                            })
                                        }}>
                                            Detener Bot
                                    </Button>
                                </div>
                            </Show>

                            {/* <div className='d-flex flex-row align-items-center justify-content-end'>
                                <div className="custom-switch-wrapper">
                                    <h5 className='mt-2'>{switchChecked ? "Desactivar el bot" : "Activar el bot"}</h5>
                                    <input
                                        type="checkbox"
                                        id="custom-switch"
                                        className='ml-2 mr-4 my-1'
                                        checked={switchChecked}
                                        onChange={e => setSwitchChecked(e.target.checked)}
                                    />
                                </div>
                            </div> */}

                            <div className="card-body">
                                <Grid
                                    className='stickyAddress'
                                    cols={columns}
                                    data={
                                        allAutomaticAsignmentRules && Object.keys(allAutomaticAsignmentRules).length > 0 ? allAutomaticAsignmentRules.items : []
                                    }
                                    page={
                                        allAutomaticAsignmentRules && Object.keys(allAutomaticAsignmentRules).length > 0
                                            ? Number(allAutomaticAsignmentRules.page)
                                            : currentPage
                                    }
                                    pages={
                                        allAutomaticAsignmentRules && Object.keys(allAutomaticAsignmentRules).length > 0
                                            ? Number(allAutomaticAsignmentRules.totalPages)
                                            : 0
                                    }
                                    total={
                                        allAutomaticAsignmentRules && allAutomaticAsignmentRules.hasOwnProperty("total") ? allAutomaticAsignmentRules.total : 0
                                    }
                                    offset={offset}
                                    onChangePage={(page) => {
                                        setCurrentPage(page);
                                    }}
                                    onChangeRange={(value) => {
                                        setOffset(value);
                                        setCurrentPage(1);
                                    }}
                                    onChangeSearch={(value) => {
                                        searchRef.current = value;

                                        reduxGetAutomaticAssigmentRules({
                                            page: currentPage,
                                            offset: offset,
                                            search: searchRef.current,
                                        });
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <SwitchOfStateBotModal
                botIsActive={true}
                AutomaticAssignmentModal={switchChecked}
                handleCloseModal={() => setSwitchChecked(false)}
                handleClickSwitch={() => {
                    reduxSwitchBotStateAutomaticAssigment({ switchTo: switchChecked ? "start" : "stop" })
                }}
            />
            <ShowJsonDetailModal
                showJsonDetailModal={showJsonDetailModal}
                json={selectedRule}
                handleCloseModal={() => setShowJsonDetailModal(false)}
            />
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        allAutomaticAsignmentRules: state.addressToAutomaticAssigmentState.allAutomaticAsignmentRules,
        switchBotAutomaticAssingment: state.addressToAutomaticAssigmentState.switchBotAutomaticAssingment,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        reduxSwitchBotStateAutomaticAssigment: (payload) =>
            dispatch({
                type: "SwitchBotStateAutomaticAssigment",
                value: payload,
            }),
        reduxGetAutomaticAssigmentRules: (payload) =>
            dispatch({
                type: "GetAutomaticAssignmentRules",
                value: payload,
            }),
        reduxResetBotAutomaticAssingment: () =>
            dispatch({
                type: "RESET_BOT_AUTOMATIC_ASIGMENT",
            }),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ParameterizationAssigner);